// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"zP-z","carouselContainer":"AP-z"};